import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCancelSubmissionDialogVisible } from "common/selectors";
import {
  SHOW_CANCEL_SUBMISSION_DIALOG,
  cancelSubmission,
} from "submission/submissionActions";
import { useTranslation } from "react-i18next";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

import IntlDialogActions from "../../general-components/IntlDialogActions";

const CancelSubmissionDialog = () => {
  const { t } = useTranslation();

  const visible = useSelector(getCancelSubmissionDialogVisible);

  const dispatch = useDispatch();
  const onStartOver = () => dispatch(cancelSubmission());
  const onCancel = () =>
    dispatch({ type: SHOW_CANCEL_SUBMISSION_DIALOG, show: false });

  return (
    <Dialog
      open={visible}
      onClose={onCancel}
      aria-labelledby="cancel-submission-dialog-title"
      aria-describedby="cancel-submission-dialog-description"
    >
      <DialogTitle id="cancel-submission-dialog-title">
        {t("submission_cancel_title")}
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          color="primary"
          id="cancel-submission-dialog-description"
        >
          {t("submission_cancel_message")}
        </DialogContentText>
      </DialogContent>

      <IntlDialogActions>
        <Button variant="contained" color="secondary" onClick={onStartOver}>
          {t("submission_cancel_yes")}
        </Button>
        <Button color="primary" onClick={onCancel}>
          {t("app_cancel")}
        </Button>
      </IntlDialogActions>
    </Dialog>
  );
};

export default CancelSubmissionDialog;
